<template>
  <base-dialog :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="$t('configurations.change_password')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('configurations.change_password')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4">
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <div class="lg:mb-2">
            <div>
              <span id="user-generate-password-old-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('configurations.old_password')}}</span>
              <el-form-item prop="old_password">
                <el-input
                  ref="oldPasswordInput"
                  show-password
                  autocomplete="off"
                  type="text"
                  class="w-full"
                  v-model="form.old_password"
                  maxlength='50'
                  aria-labelledby="user-generate-password-old-label"
                >
                <template v-if="form.old_password" slot="suffix">
                  <base-clear-input-button
                    aria-label="Limpiar campo de contraseña antigua"
                    @clear="form.old_password = ''"
                  />
                </template>
              </el-input>
              </el-form-item>
              <base-password-form-item v-model="form.password" autocomplete="new-password"/>
              <base-password-form-item v-model="form.repeat_password" :password="form.password" autocomplete="new-password" repeat />
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button class="w-full" @click="toggleDialog" mode="secondary-phantom-blue" text="Cancelar" :loading="isGeneralLoading"/>
      <base-button mode="secondary-phantom-blue" class="w-full" text="Aplicar" @click="handleClick('ruleForm')" :loading="isGeneralLoading"/>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from './base/BaseDialog.vue'
import { newPassword } from '@/services/auth/newPassword'

export default
{
  name: 'user-generate-password-dialog',
  components: {
    BaseDialog,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    userId: {
      type: Number,
      default: -1
    }
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      form: {
        old_password: null,
        password: null,
        repeat_password: null
      },
      rules: {
        old_password: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
      }
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      if (value) {
        this.fixAccesibilityElPasword()
      }
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    }
  },
  mounted: async function () {
    this.fixAccesibilityElPasword()
  },
  methods: {
    fixAccesibilityElPasword () {
      this.$nextTick(() => {
      // Timeout para esperar a que se rendericen los iconos
        setTimeout(() => {
          this.fixAccesibilityElInputPassword(this.$refs.oldPasswordInput, this.$i18n.t('aria.elementui.input.password'))
        }, 1000)
      })
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.form.old_password = null
      this.form.password = null
      this.form.repeat_password = null
      this.$emit('toggleDialog')
    },
    handleClick: async function (ruleForm) {
      try {
        this.$store.commit('setAjaxRequestPending', true)
        this.$store.commit('setIsLoading', true)
        this.$refs[ruleForm].validate(async valid => {
          if (valid) {
            const response = await newPassword(this.form.old_password, this.form.password)
            if (response.blnError === true) {
              this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
            } else {
              this.doFeedback('Contraseña cambiada con éxito', 'success')
              this.toggleDialog()
            }
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
          }
        })
      } catch (error) {
        // console.log(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
  }
}
</script>

<style lang="scss" scoped></style>
